import { render, staticRenderFns } from "./Gallery11.vue?vue&type=template&id=ef333fa8&scoped=true&"
import script from "./Gallery11.vue?vue&type=script&lang=js&"
export * from "./Gallery11.vue?vue&type=script&lang=js&"
import style0 from "./Gallery11.vue?vue&type=style&index=0&id=ef333fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef333fa8",
  null
  
)

export default component.exports